function getSubmitDataUrl(): string {
  return (useRuntimeConfig().public.submitDataUrl as string) || "";
}

export { getSubmitDataUrl };
